import { render, staticRenderFns } from "./selectCategory.vue?vue&type=template&id=daff25ce&scoped=true&"
import script from "./selectCategory.vue?vue&type=script&scoped=true&lang=js&"
export * from "./selectCategory.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./selectCategory.vue?vue&type=style&index=0&id=daff25ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daff25ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daff25ce')) {
      api.createRecord('daff25ce', component.options)
    } else {
      api.reload('daff25ce', component.options)
    }
    module.hot.accept("./selectCategory.vue?vue&type=template&id=daff25ce&scoped=true&", function () {
      api.rerender('daff25ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/selectCategory.vue"
export default component.exports